import { ifFeature } from '@bamboohr/utils/lib/feature';
import { makeStyles } from '~styles';

export const useGroupLegendStyles = makeStyles<{ hasNote: boolean }>({ name: 'GroupLegend' })(({ spacing }, { hasNote }) => ({
	legendContainer: {
		marginBottom: ifFeature('encore', spacing(1.5), hasNote ? 8 : 6),
	},
}));
